import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { Col, Row, Button } from 'react-bootstrap';
import {
	BsEmojiSunglasses as EmojiSunglasses,
	BsPeople as People,
} from 'react-icons/bs';

dayjs.extend(relativeTime);

interface Notification {
	id: number | string;
	text: string;
	link: string;
	type_id: number | string;
	created_at: string;
	type: string;
}

interface NotificationItemProps {
	notification: Notification;
}

const NotificationItem = ({ notification }: NotificationItemProps) => {
	const handleViewLead = async (notification_id: number | string) => {
		/* eslint-disable-next-line no-undef, @typescript-eslint/no-explicit-any */
		await (window as any).jQuery.viewSingleAction(notification_id);
	};

	return (
		<li className="notify-block unread-notification-js">
			<div className="notification-wrapper">
				<div className="noti-icon">
					<People />
				</div>
				<div className="noti-from">
					<div className="noti-info">
						<div className="client-name flex-grow-1">
							<span className="insert-name">{notification.text}</span>
						</div>
						<a
							className="view-lead notification-link flex-shrink-0 ms-2"
							href={`${notification.link}?search=${notification.type_id}`}
							onClick={() => handleViewLead(notification.id)}
						>
							View Lead
						</a>
					</div>
					<div className="noti-date">
						<div className="lead-date">
							{dayjs(notification.created_at).fromNow()}
						</div>
					</div>
				</div>
			</div>
		</li>
	);
};

interface NotificationHeaderProps {
	count: number;
}

const NotificationHeader = ({ count }: NotificationHeaderProps) => {
	const handleViewAll = async () => {
		/* eslint-disable-next-line no-undef, @typescript-eslint/no-explicit-any */
		await (window as any).jQuery.viewAllAction();
	};

	return (
		<div className="bay-notifications-header">
			LEADS
			<div className="d-flex flex-grow-1 flex align-items-center justify-content-end">
				<span className="badge me-2">{count}</span>
				<Button
					className="py-1"
					size="sm"
					variant="secondary"
					onClick={() => handleViewAll()}
				>
					View All
				</Button>
			</div>
		</div>
	);
};

interface NotificationFeedSocialProps {
	feedArray: Notification[];
}

const NotificationFeedSocial = ({ feedArray }: NotificationFeedSocialProps) => {
	const notificationTypes = [{ lead: 'lead' }];

	return (
		<div
			className="feed-wrapper"
			style={{ padding: '0px 0.25rem', paddingBottom: 52 }}
		>
			{feedArray?.length > 0 ? (
				notificationTypes.map((obj, index) => {
					const item = Object.keys(obj)[0];
					return feedArray.filter((e) => e.type === item).length > 0 ? (
						<div key={index} className="item-notification">
							<div
								className="bay-notifications"
								id={`iq_notifications_${item}`}
							>
								<NotificationHeader
									count={feedArray.filter((e) => e.type === item).length}
								/>
								{feedArray
									.filter((e) => e.type === item)
									.map((notification, index) => {
										return (
											<NotificationItem
												key={index}
												notification={notification}
											/>
										);
									})}
							</div>
						</div>
					) : null;
				})
			) : (
				<div className="p-2 align-content-center justify-content-center">
					<Row>
						<Col>
							<span className="h3 text-muted">Congrats!</span>
							<p className="text-dark">
								Looks like you're all caught up. <EmojiSunglasses size={20} />
							</p>
						</Col>
					</Row>
				</div>
			)}
		</div>
	);
};

export default NotificationFeedSocial;
